export default {
    title: 'Recognition',
    subtitle: 'The recognitions your colleagues sent you.',
    carousel: 'Carousel of the recognitions you received',
    carouselCaption: 'Messages on the fly from your recent recognitions',
    previous: 'Previous recognition',
    next: 'Next recognition',
    position: '{{position}} of {{total}}',
    openFeed: 'Open {{sender}}’s recognition in the Recognition feed',
    likeCount: '{{count}} likes',
    likeCount_one: '{{count}} like',
    likeCount_other: '{{count}} likes',
    commentCount: '{{count}} comments',
    commentCount_one: '{{count}} comment',
    commentCount_other: '{{count}} comments',
    empty: 'You have not received a recognition yet. The next one may well answer the one you send.',
    recognizeColleague: 'Recognize a colleague',
    unavailable: 'Your recognitions cannot be reached right now.',
    retry: 'Try again',
    loadError: 'This section could not be loaded. Try again later.',
};
